// extracted by mini-css-extract-plugin
export default {"defaultIn":"Animations_defaultIn__rgIvd","fadeIn":"Animations_fadeIn__FDmBr"};